/* eslint-disable import/prefer-default-export */
export const urlGenerator = (urlParams, url) => Object.keys(urlParams).reduce((u, key) => u.replace(`{${key}}`, urlParams[key]), url);